import React from 'react';
import AutocompleteInput from '../inputs/AutocompleteInput';
import { COUNTRIES, REGIONS } from '../../../constants/autocompleteData';

const LocationFilters = ({ filters, onFilterChange }) => {
  return (
    <>
      <div style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '20px',
        marginBottom: '20px'
      }}>
        <AutocompleteInput
          label="Person Country"
          value={filters.person_country}
          onChange={(value) => onFilterChange('person_country', value)}
          placeholder="Type to search countries..."
          suggestions={COUNTRIES}
          hint="Person's location - country"
        />
        <AutocompleteInput
          label="Person State/Region"
          value={filters.person_state}
          onChange={(value) => onFilterChange('person_state', value)}
          placeholder="Type to search states/regions..."
          suggestions={REGIONS}
          hint="Person's location - state/region"
        />
      </div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '20px'
      }}>
        <AutocompleteInput
          label="Company Country"
          value={filters.company_country}
          onChange={(value) => onFilterChange('company_country', value)}
          placeholder="Type to search countries..."
          suggestions={COUNTRIES}
          hint="Company headquarters - country"
        />
        <AutocompleteInput
          label="Company State/Region"
          value={filters.company_state}
          onChange={(value) => onFilterChange('company_state', value)}
          placeholder="Type to search states/regions..."
          suggestions={REGIONS}
          hint="Company headquarters - state/region"
        />
      </div>
    </>
  );
};

export default LocationFilters;
